import StatusBarHeight from "@/components/status-bar-height";
import NavigationBar, { NavigationBarProps } from "./NavigationBar";
import SafeArea from "@/components/safe-area";
interface Props extends NavigationBarProps {}

export default function Navigation(props: Props) {
	return (
		<div className="px-4">
			<StatusBarHeight />
			<SafeArea position="top" />
			<NavigationBar {...props} />
		</div>
	);
}
